import { Checkbox } from 'primereact/checkbox';
import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import * as myconst from "../../constants/index"
import { InputTextarea } from 'primereact/inputtextarea';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';

interface arr_type {
  value: string;
  label: string;
}

const StepThree = ({ handlePrev, handleNext, goOnFirst, isLinear, goOnLast, methods, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const creation_skills_value = watch('creation_skills');
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }
  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['creation_skills', 'comfort_level', 'past_experience']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }

  const handleCustomChange = (e: React.ChangeEvent<HTMLTextAreaElement>, field: any, fieldName: string) => {
    field.onChange(e);
    clearErrors(fieldName);
  };

  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])

  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Do you have video editing, writing, or design experience?</label>
                <Controller
                  name="creation_skills"
                  control={methods.control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('creation_skills').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("creation_skills");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox d-flex align-items-center">
                            <Checkbox
                              inputId={'creation_skills'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                clearErrors('creation_skills')
                                // If checked, add the value to the array; otherwise, remove it
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                            {option.label === 'Other' && creation_skills_value.includes('other') &&
                              <InputText style={{ fontSize: "14px" }} className="ms-4" {...register("creation_skills_other")} />
                            }
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("creation_skills")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Are you comfortable on camera, podcasting, or writing?</label>
                <Controller
                  name="comfort_level"
                  control={methods.control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('comfort_level').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("comfort_level");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox">
                            <Checkbox
                              inputId={'comfort_level'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                clearErrors('comfort_level')
                                // If checked, add the value to the array; otherwise, remove it
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("comfort_level")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Do you have any unique expertise or personal experiences to share?</label>
                {/* <InputTextarea style={{ fontSize: "14px" }} rows={6} className="form-control p-inputtext-lg" {...register("past_experience", { required: { value: true, message: "Past Experiences is required" } })} placeholder="Add your experiences here..." /> */}
                <Controller
                  name={`past_experience`}
                  control={control}
                  defaultValue=""
                  rules={{
                    required: 'Please add your past experience'
                  }}
                  render={({ field }) => (
                    <InputTextarea
                      placeholder="Add your experiences here..."
                      rows={6}
                      style={{ fontSize: "14px" }}
                      {...field}
                      onChange={(e) => handleCustomChange(e, field, "past_experience")}
                    />
                  )}
                />
                {getFormErrorMessage("past_experience")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={goOnFirst} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{'Next >'}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={goOnLast}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepThree